// La vitrina de los costados del onboarding en desktop
// (ADR-2026-10-02-onboarding-v2-vitrina-desktop): a la izquierda, imágenes creadas con Atlas
// (con la foto de la que salieron); a la derecha, lo que dicen las marcas que lo usan.

export interface ImagenDeVitrina {
  /** Lo que generó Atlas. */
  src: string;
  /** La foto de la que partió, chiquita en la esquina ("Antes"). */
  antes: string;
  tipo: 'Para redes' | 'Foto de catálogo' | 'Fondo blanco';
  rubro: string;
}

const R = '/images/onboarding/rubros';
/** Las generadas, en versión liviana (600px de ancho, ~100 KB): la tarjeta mide 320px y las
 *  originales pesaban hasta 842 KB, así que tardaban en aparecer (`public/images/onboarding/vitrina`). */
const V = '/images/onboarding/vitrina';

export const IMAGENES_DE_VITRINA: ImagenDeVitrina[] = [
  { src: `${V}/moda-cartera-verde-redes.jpg`, antes: `${R}/moda/cartera-verde/product.jpg`, tipo: 'Para redes', rubro: 'Moda' },
  { src: `${V}/gastronomia-hamburguesa-catalogo.jpg`, antes: `${R}/gastronomia/hamburguesa/product.jpg`, tipo: 'Foto de catálogo', rubro: 'Gastronomía' },
  { src: `${V}/hogar-silla-redes.jpg`, antes: `${R}/hogar/silla/product.jpg`, tipo: 'Para redes', rubro: 'Hogar y deco' },
  { src: `${V}/belleza-lapiz-catalogo.jpg`, antes: `${R}/belleza/lapiz/product.jpg`, tipo: 'Foto de catálogo', rubro: 'Belleza' },
  { src: `${V}/moda-camisa-hombre-redes.jpg`, antes: `${R}/moda/camisa-hombre/product.jpg`, tipo: 'Para redes', rubro: 'Moda' },
  { src: `${V}/gastronomia-pizza-redes.jpg`, antes: `${R}/gastronomia/pizza/product.jpg`, tipo: 'Para redes', rubro: 'Gastronomía' },
  { src: `${V}/hogar-mesa-luz-catalogo.jpg`, antes: `${R}/hogar/mesa-luz/product.jpg`, tipo: 'Foto de catálogo', rubro: 'Hogar y deco' },
  { src: `${V}/belleza-mascara-redes.jpg`, antes: `${R}/belleza/mascara/product.jpg`, tipo: 'Para redes', rubro: 'Belleza' },
];

export interface ReviewDeVitrina {
  texto: string;
  nombre: string;
  negocio: string;
}

/**
 * ⚠️ EJEMPLOS DE DISEÑO, NO SON REVIEWS REALES.
 *
 * Están para ver cómo funciona la vitrina. Antes de prender el onboarding de marca para
 * usuarios reales hay que reemplazarlas por testimonios reales, con permiso de quien los
 * dio: mostrar reviews inventadas como si fueran de clientes es publicidad engañosa
 * (ADR-2026-10-02-onboarding-v2-vitrina-desktop). Sólo se muestran en desarrollo
 * (`import.meta.env.DEV`) hasta entonces; ver `reviewsDeLaVitrina`.
 */
const REVIEWS_DE_EJEMPLO: ReviewDeVitrina[] = [
  { texto: 'Subí la foto de una cartera y en un minuto tenía la publicación lista. Ya no armo producciones para cada lanzamiento.', nombre: 'Lucía M.', negocio: 'Marroquinería' },
  { texto: 'Las fotos de los platos salen con la luz y el estilo de mi local. Mis seguidores no notan la diferencia con una sesión.', nombre: 'Martín R.', negocio: 'Hamburguesería' },
  { texto: 'Conecté la tienda y tenía todo el catálogo adentro. Elegí un producto y salieron tres piezas con mis colores.', nombre: 'Carolina P.', negocio: 'Tienda de deco' },
  { texto: 'Lo que más me sirve es que respeta mi marca: el logo, la tipografía y cómo hablo con mis clientas.', nombre: 'Sofía G.', negocio: 'Cosmética natural' },
  { texto: 'Antes tardaba una semana en tener fotos para la temporada. Ahora las tengo el mismo día que llega la mercadería.', nombre: 'Diego L.', negocio: 'Indumentaria masculina' },
  { texto: 'Hago los anuncios de la semana en una tarde. Los resultados en Meta mejoraron desde que las fotos se ven profesionales.', nombre: 'Valentina C.', negocio: 'Tienda online' },
];

/** Las reviews que se muestran. Vacía en producción mientras sólo haya ejemplos: la vitrina muestra sólo imágenes. */
export function reviewsDeLaVitrina(): ReviewDeVitrina[] {
  return import.meta.env.DEV ? REVIEWS_DE_EJEMPLO : [];
}

/** Iniciales para el avatar de quien opina ("Lucía M." → "LM"). */
export function iniciales(nombre: string): string {
  return nombre
    .split(/\s+/)
    .map((p) => p.replace(/[^A-Za-zÁÉÍÓÚÑáéíóúñ]/g, '').charAt(0))
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}
